enum CodTipoDocumento {
  ActaDefuncionLegalizadaPortal = 4,
  ActaDefuncionLegalizada = 16,
  ActaNacimientoConyugeLegalizada = 17,
  ActaMatrimonioConyugeLegalizada = 19,
  ActaNacimientoHijo = 36,
  CertifiacionMedicoGestacion = 34,
  OtrasActas = 41,
  ComprobanteDeCuenta= 65,
  CedulaHijoMayorDeEdad = 37,
  CopiaCedulaAfiliadoFallecido = 38,
  CopiaCedulaBeneficiariosNoLegales = 42,
  CedulaReverso=212,
  CedulaDelantera=18
}

export default CodTipoDocumento;
